import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const FooterWrapperComponent = styled(FlexRow)`
    border-top: none;
    padding-right: 16px;
    margin-top: auto;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    height: 51px;
`;
